import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Home = () => {
  const { t } = useTranslation()
  const { search } = useLocation()
  const gameId = new URLSearchParams(search).get('gameId')
  const SomethingWentWrongPage = () => (
    <div className='pt-5 static-root h-100 page-not-found bg-container' style={{ color: '#FFF' }}>
      <h2 className='text-center'>
        <i className='mx-2 fa fa-exclamation-triangle' aria-hidden='true' />
        {t('Error')}
      </h2>
      <div className='mt-3 notFound text-center'>
        <p>
          {t('Something went wrong. Please try again.')}
        </p>
      </div>
    </div>
  )

  const gameComponent = useMemo(() => {
    switch (parseInt(gameId)) {
      default: return <SomethingWentWrongPage />
    }
  }, [gameId])

  return (
    <>
      {gameComponent}
    </>
  )
}

export default Home
